import type { ReactNode } from 'react'
import { Badge } from './Badge'

type Props = {
  readonly badge?: string
  readonly children: ReactNode
}

/**
 * Header component. Displays a badge if badge text is provided
 * @param badge - The badge text to display
 * @returns JSX.Element | null
 */
export function Header({ badge, children }: Props) {
  return (
    <div className="flex items-end justify-center bg-neutral-black py-4 md:pt-3">
      <Badge>{badge}</Badge>
      <h3 className="text-white text-2xl md:text-3xl leading-none m-0">
        {children}
      </h3>
    </div>
  )
}
